import { Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import WhatsAppButton from '@/components/layout/WhatsAppButton'

// Layout
import Header from '@/components/layout/Header'
import Footer from '@/components/layout/Footer'

// Pages
import HomePage from './pages/HomePage'
import AboutPage from './pages/AboutPage'
import AccountPage from './pages/AccountPage'
import CartPage from './pages/CartPage'
import ContactPage from './pages/ContactPage'
import ExpressDeliveryPage from './pages/ExpressDeliveryPage'
import FAQPage from './pages/FAQPage'
import LoginPage from './pages/LoginPage'
import OffersPage from './pages/OffersPage'
import PackagingPage from './pages/PackagingPage'
import PrivacyPage from './pages/PrivacyPage'
import ProductsPage from './pages/ProductsPage'
import ProductDetailPage from './pages/ProductDetailPage'
import ReturnsPage from './pages/ReturnsPage'
import ShippingPage from './pages/ShippingPage'
import TermsPage from './pages/TermsPage'
import WishlistPage from './pages/WishlistPage'

// Admin Layout
import AdminLayout from '@/components/admin/AdminLayout'
import AdminDashboard from './pages/admin/AdminDashboard'
import AdminLogin from './pages/admin/AdminLogin'
import AdminProducts from './pages/admin/AdminProducts'
import AdminProductNew from './pages/admin/AdminProductNew'
import AdminProductDetail from './pages/admin/AdminProductDetail'
import AdminOrders from './pages/admin/AdminOrders'
import AdminOrderDetail from './pages/admin/AdminOrderDetail'
import AdminPayments from './pages/admin/AdminPayments'
import AdminUsers from './pages/admin/AdminUsers'
import AdminCategories from './pages/admin/AdminCategories'
import AdminCollections from './pages/admin/AdminCollections'
import AdminSettings from './pages/admin/AdminSettings'
import AdminWishlist from './pages/admin/AdminWishlist'
import AdminAnalytics from './pages/admin/AdminAnalytics'

function App() {
  return (
    <div className="min-h-screen flex flex-col">
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={
          <>
            <Header />
            <HomePage />
            <Footer />
          </>
        } />
        
        <Route path="/about" element={
          <>
            <Header />
            <AboutPage />
            <Footer />
          </>
        } />
        
        <Route path="/account" element={
          <>
            <Header />
            <AccountPage />
            <Footer />
          </>
        } />
        
        <Route path="/cart" element={
          <>
            <Header />
            <CartPage />
            <Footer />
          </>
        } />
        
        <Route path="/contact" element={
          <>
            <Header />
            <ContactPage />
            <Footer />
          </>
        } />
        
        <Route path="/express-delivery" element={
          <>
            <Header />
            <ExpressDeliveryPage />
            <Footer />
          </>
        } />
        
        <Route path="/faq" element={
          <>
            <Header />
            <FAQPage />
            <Footer />
          </>
        } />
        
        <Route path="/login" element={
          <>
            <Header />
            <LoginPage />
            <Footer />
          </>
        } />
        
        <Route path="/offers" element={
          <>
            <Header />
            <OffersPage />
            <Footer />
          </>
        } />
        
        <Route path="/packaging" element={
          <>
            <Header />
            <PackagingPage />
            <Footer />
          </>
        } />
        
        <Route path="/privacy" element={
          <>
            <Header />
            <PrivacyPage />
            <Footer />
          </>
        } />
        
        <Route path="/products" element={
          <>
            <Header />
            <ProductsPage />
            <Footer />
          </>
        } />
        
        <Route path="/products/:slug" element={
          <>
            <Header />
            <ProductDetailPage />
            <Footer />
          </>
        } />
        
        <Route path="/products/classification/:slug" element={
          <>
            <Header />
            <ProductsPage />
            <Footer />
          </>
        } />
        
        <Route path="/returns" element={
          <>
            <Header />
            <ReturnsPage />
            <Footer />
          </>
        } />
        
        <Route path="/shipping" element={
          <>
            <Header />
            <ShippingPage />
            <Footer />
          </>
        } />
        
        <Route path="/terms" element={
          <>
            <Header />
            <TermsPage />
            <Footer />
          </>
        } />
        
        <Route path="/wishlist" element={
          <>
            <Header />
            <WishlistPage />
            <Footer />
          </>
        } />
        
        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="products" element={<AdminProducts />} />
          <Route path="products/new" element={<AdminProductNew />} />
          <Route path="products/:id" element={<AdminProductDetail />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="orders/:id" element={<AdminOrderDetail />} />
          <Route path="payments" element={<AdminPayments />} />
          <Route path="users" element={<AdminUsers />} />
          <Route path="categories" element={<AdminCategories />} />
          <Route path="collections" element={<AdminCollections />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="wishlist" element={<AdminWishlist />} />
          <Route path="analytics" element={<AdminAnalytics />} />
        </Route>
      </Routes>
      
      <WhatsAppButton />
      
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: "#1f2937",
            color: "#fff",
          },
        }}
      />
    </div>
  )
}

export default App
